import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { QueryClientConfig } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://87194648df54db4ba0168b71a54a31f4@o4510347572936704.ingest.us.sentry.io/4510350580645888',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const queryConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 0, // 5 minutes
      gcTime: 0, // 10 minutes
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
};

const queryClient = new QueryClient(queryConfig);

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
